// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"de97b568","453":"fb1c6ae2","455":"6e435e44","482":"aaf81950","544":"4f45ece0","708":"ff7ebb2b","831":"dfa83f49"}[chunkId] + ".chunk.js";
};